import "../img/events/event-attending-icon.png";
import "../img/events/event-hosted-icon.png";
import "../img/events/banner.png";
import "../img/events/event-resource.png";